// Scene customization defaults
export const defaultSceneConfig = {
  // Avatar model
  avatar: {
    url: '/models/assistia-v6/model.gltf',
  },

  // Hover animation
  hover: {
    enabled: true,
    scale: 1.02,
    liftY: 0.02,
    transitionSpeed: 0.1,
  },

  // Materials overrides
  materials: {
    body: {
      roughness: 1.7,
      metalness: 0.0,
      color: '#ffffff',
      envMapIntensity: 0.8,
    },
    eyes: {
      roughness: 0.1,
      metalness: 0.0,
      color: '#ffffff',
      envMapIntensity: 0.5,
    },
    teeth: {
      roughness: 0.1,
      metalness: 0.0,
      color: '#ffffff',
      envMapIntensity: 0.7,
    },
    hair: {
      roughness: 0.5,
      metalness: 0.0,
      color: '#000000',
      envMapIntensity: 0.3,
    },
    tshirt: {
      roughness: 0.8,
      metalness: 0.0,
      color: '#ffffff',
      envMapIntensity: 0.5,
    },
  },

  // Background
  background: {
    type: 'color', // 'hdr' | 'image' | 'video' | 'color'
    hdrUrl: '/images/studio_small_08_4k.hdr',
    hdrRotation: 0,
    hdrIntensity: 1,
    imageUrl: '',
    videoUrl: '',
    color: '#0f172a',
  },

  // Lighting
  lighting: {
    ambient: {
      enabled: true,
      color: '#ffffff',
      intensity: 1.25,
    },
    directional: {
      enabled: true,
      color: '#ffffff',
      intensity: 1.7,
      position: { x: 5, y: 10, z: 7 },
    },
    point: {
      enabled: false,
      color: '#ffaa77',
      intensity: 0.8,
      position: { x: -3, y: 4, z: 3 },
    },
  },

  // Expression (manual morph overrides)
  expression: {
    smile: 0,
  },

  // Animation (idle / head movement)
  animation: {
    headAmplitude: 1,
    headSpeed: 1,
    neckAmplitude: 1,
    neckSpeed: 1,
    returnSpeed: 1,
    subtleFactor: 0.2,
    blinkIntervalMin: 2,
    blinkIntervalMax: 4,
    blinkSpeed: 15,
  },
};

export function loadSceneConfig() {
  try {
    const saved = localStorage.getItem('three-gpt-scene-config');
    if (saved) {
      const parsed = JSON.parse(saved);
      const merged = deepMergeScene(defaultSceneConfig, parsed);
      const previousDefaults = ['/models/assistia-v5/model.gltf', 'https://assistia-9b4.pages.dev/models/assistia-v5/model.gltf', 'https://pub-5b9974d1b333476780d948250f800075.r2.dev/model.glb', '/model.glb', '/models/assistia-human.glb', '/models/assistia-human.glb?v=2', '/models/assistia-human.glb?v=3', '/models/assistia-human.glb?v=4', '/models/assistia-human.glb?v=5'];
      if (previousDefaults.includes(merged.avatar?.url)) merged.avatar.url = defaultSceneConfig.avatar.url;
      // Validate and fix broken URLs
      if (merged.background) {
        if (merged.background.type === 'hdr') {
          const hdr = merged.background.hdrUrl || '';
          const isValid = /\.(hdr|exr)$/i.test(hdr);
          if (!isValid) {
            merged.background.hdrUrl = defaultSceneConfig.background.hdrUrl;
          }
        }
        if (merged.background.type === 'image') {
          const img = merged.background.imageUrl || '';
          const isValid = /\.(jpg|jpeg|png|webp|gif|bmp|tiff)$/i.test(img);
          if (!isValid) {
            merged.background.imageUrl = '';
          }
        }
        if (merged.background.type === 'video') {
          const vid = merged.background.videoUrl || '';
          const isValid = /\.(mp4|webm|ogg|mov)$/i.test(vid);
          if (!isValid) {
            merged.background.videoUrl = '';
          }
        }
      }
      return merged;
    }
  } catch (e) {
    console.warn('Failed to load scene config:', e);
  }
  return JSON.parse(JSON.stringify(defaultSceneConfig));
}

export function saveSceneConfig(config) {
  try {
    localStorage.setItem('three-gpt-scene-config', JSON.stringify(config));
  } catch (e) {
    console.warn('Failed to save scene config:', e);
  }
}

export function resetSceneConfig() {
  localStorage.removeItem('three-gpt-scene-config');
  return JSON.parse(JSON.stringify(defaultSceneConfig));
}

function deepMergeScene(defaults, overrides) {
  const result = JSON.parse(JSON.stringify(defaults));
  for (const key of Object.keys(overrides)) {
    if (typeof overrides[key] === 'object' && overrides[key] !== null && !Array.isArray(overrides[key])) {
      result[key] = { ...result[key], ...overrides[key] };
    } else {
      result[key] = overrides[key];
    }
  }
  return result;
}
